import { DISCOVER_DEFAULT_TECHNICAL_ERROR_KEY } from 'components/discover/shared';
import type { FetchStatus } from 'hooks/useFetchData';
import { FC } from 'react';

import { ErrorWithRetry } from '../../shared/ErrorWithRetry';
import type { RecommendedResearchItem } from './model';
import { RecommendedResearch } from './presentation';
import { RecommendedResearchSkeleton } from './skeletons';

interface RecommendedResearchContainerProps {
  status: FetchStatus;
  items: Nullable<ReadonlyArray<RecommendedResearchItem>>;
  retry: Nullable<() => void>;
  className?: string;
}

export const RecommendedResearchContainer: FC<RecommendedResearchContainerProps> = ({
  status,
  items,
  retry,
  className,
}) => {
  if (status === 'empty') {
    return null;
  }

  if (status === 'unauthorized') {
    throw new Error('Unauthorized for Insight/Research');
  }

  return (
    <>
      {status === 'loading' && <RecommendedResearchSkeleton count={10} />}
      {status === 'success' && <RecommendedResearch data={items!} className={className} />}
      {status === 'error' && (
        <ErrorWithRetry
          onRetry={retry}
          e2e="recommended-research-error"
          msgKey={DISCOVER_DEFAULT_TECHNICAL_ERROR_KEY}
        />
      )}
    </>
  );
};
